<div class="modal-header">
    <h3 class="modal-title">
        {{ titulo }}
    </h3>
</div>
<div class="modal-body">
    <table class="table table-striped">
        <thead>
            <tr>
                <th>Correos destinatarios</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td class="d-flex align-items-center">
                  <input
                    type="email"
                    class="form-control me-2"
                    [formControl]="emailFormControl"
                    maxlength="50"
                    placeholder="email@live.com"
                  />
                  <button
                    class="btn btn-sm btn-success"
                    [disabled]="emailFormControl.invalid || chequearMail()"
                    (click)="agregarMail()"
                  >
                    <i class="fa fa-plus"></i>
                  </button>
                </td>
              </tr>
              <tr *ngFor="let email of emails; let i = index;">
                <td class="d-flex justify-content-between align-items-center">
                  <span>{{ email }}</span>
                  <button (click)="eliminarMail(i)" class="btn btn-sm btn-danger">
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
        </tbody>
    </table>
    
</div>
<div class="modal-footer">
    <button (click)="guardar()" [disabled]="emails.length == 0" class="btn btn-primary">Aceptar</button>
    <button (click)="cerrar()" class="btn btn-secondary">Cancelar</button>
</div>